/**
 * Novčani iznosi na 2 decimale — isto kao na serveru (C# decimal, MidpointRounding.AwayFromZero;
 * DiscountAllocator / FiscalizationHost), da klijent i server dođu do istog iznosa do pare.
 */

/** Zaokruži na 2 decimale, polovina od nule. Šum binarnog zapisa (12.345 je u stvari 12.34499…)
 *  se prvo skida na 15 značajnih cifara, pa rezultat odgovara decimalnom računu. */
export function roundMoney(value: number): number {
  const cents = Math.round(Number((Math.abs(value) * 100).toPrecision(15)));
  return Math.sign(value) * cents / 100;
}

/**
 * Raspodeli iznos (2 decimale) po težinama tako da je zbir delova TAČNO taj iznos
 * (largest-remainder): svaki deo se odseče na cent, preostali centi idu delovima sa najvećim
 * ostatkom (pa većom težinom, pa redom). Deo sa težinom ≤ 0 dobija 0; ako nijedna težina nije
 * pozitivna, sve ide prvom delu. Isto kao serverski SplitByWeight / AllocateLargestRemainder.
 */
export function splitByWeight(target: number, weights: number[]): number[] {
  const result = weights.map(() => 0);
  if (!weights.length) {
    return result;
  }

  const totalWeight = weights.reduce((s, w) => s + w, 0);
  if (totalWeight <= 0) {
    result[0] = roundMoney(target);
    return result;
  }

  const targetCents = Math.round(roundMoney(target) * 100);
  const cents = weights.map(() => 0);
  const rest = weights.map(() => -1);
  let allocated = 0;
  weights.forEach((w, i) => {
    if (w <= 0) {
      return;
    }
    const ideal = Number((targetCents * w / totalWeight).toPrecision(12));
    cents[i] = Math.floor(ideal);
    rest[i] = ideal - cents[i];
    allocated += cents[i];
  });

  weights
    .map((w, i) => i)
    .filter(i => weights[i] > 0)
    .sort((a, b) => (rest[b] - rest[a]) || (weights[b] - weights[a]) || (a - b))
    .slice(0, Math.max(targetCents - allocated, 0))
    .forEach(i => cents[i]++);

  return cents.map(c => c / 100);
}
